import './CardsConfigChannels.scss';
// @vendor
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// @utilities
const { formatText } = require('core/i18n').i18n;
// @actions
import { channelsSetRequested } from 'actions/cardControl';
// @components
import TextToggle from 'components/commons/textToggle/textToggle';
import { getCard } from 'selectors/cards';
// @assets
import cardChannelAtm from 'assets/images/card-channel-atm.svg';
import cardChannelTpv from 'assets/images/card-channel-tpv.svg';
import cardChannelOnline from 'assets/images/card-channel-online.svg';
// @tagging
import { EVENT_CARD_CONTROL, EVENT_ATMS, EVENT_IN_PERSONAL_PURCHASES, EVENT_ONLINE_PURCHASES } from 'utilities/tagging';

class CardsConfigChannels extends Component {
    render() {
        const { card, setChannel } = this.props;
        const pan = card.contract.number.padStart(card.contract.number.length, '0');
        const lastDigitsPan = card.number.slice(-4)
        return (
            <section className="list-channels">
                <div className="panel">
                    <img
                        src={cardChannelAtm}
                        alt={formatText('cardsChannels-atm')}
                        className="panel--img"
                    />
                    <div className="panel--text">
                        <p className="panel--title">
                            {formatText('cardsChannels-atm')}
                        </p>
                        <p className="panel--description">
                            {formatText('cardsChannels-atmDesc')}
                        </p>
                    </div>
                    {
                        card.channels &&
                        <TextToggle
                            checked={card.channels.atm}
                            onClick={() => { setChannel({ active: !card.channels.atm, cardId: card.cardId, pan, channel: 'atm', lastDigitsPan }) }}
                            eventCategory={EVENT_CARD_CONTROL}
                            eventTag={EVENT_ATMS}
                            textCheck='ON'
                            textUncheck='OFF'
                            isCardControlSection
                        />
                    }
                </div>
                <div className="panel">
                    <img
                        alt={formatText('cardsChannels-tpv')}
                        className="panel--img"
                        src={cardChannelTpv}
                    />
                    <div className="panel--text">
                        <p className="panel--title">
                            {formatText('cardsChannels-tpv')}
                        </p>
                        <p className="panel--description">
                            {formatText('cardsChannels-tpvDesc')}
                        </p>
                    </div>
                    {
                        card.channels &&
                        <TextToggle
                            checked={card.channels.tpv}
                            onClick={() => { setChannel({ active: !card.channels.tpv, cardId: card.cardId, pan, channel: 'tpv', lastDigitsPan }) }}
                            eventCategory={EVENT_CARD_CONTROL}
                            eventTag={EVENT_IN_PERSONAL_PURCHASES}
                            textCheck='ON'
                            textUncheck='OFF'
                            isCardControlSection
                        />
                    }
                </div>
                <div className="panel">
                    <img
                        alt={formatText('cardsChannels-online')}
                        className="panel--img"
                        src={cardChannelOnline}
                    />
                    <div className="panel--text">
                        <p className="panel--title">
                            {formatText('cardsChannels-online')}
                        </p>
                        <p className="panel--description">
                            {formatText('cardsChannels-onlineDesc')}
                        </p>
                    </div>
                    {
                        card.channels &&
                        <TextToggle
                            checked={card.channels.online}
                            onClick={() => { setChannel({ active: !card.channels.online, cardId: card.cardId, pan, channel: 'online', lastDigitsPan }) }}
                            eventCategory={EVENT_CARD_CONTROL}
                            eventTag={EVENT_ONLINE_PURCHASES}
                            textCheck='ON'
                            textUncheck='OFF'
                            isCardControlSection
                        />
                    }
                </div>
            </section>
        );
    }
}


CardsConfigChannels.propTypes = {
    card: PropTypes.object.isRequired,
    cardId: PropTypes.string.isRequired,
    setChannel: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => ({
    card: getCard(state, props),
});

const mapDispatchToProps = dispatch => ({
    setChannel: ({ active, cardId, channel, pan, lastDigitsPan }) => dispatch(channelsSetRequested({ cardId, channels: { [channel]: active }, pan, lastDigitsPan })),
});


export default connect(mapStateToProps, mapDispatchToProps)(CardsConfigChannels);
